<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3"></div>
    </div>

    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-person me-2 fs-1 text-primary"></i>Usuario
                    </h4>
                </div>

                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton" [ngClass]="{'no-mostrar-boton-disabled': botonEditar === false}" [disabled]=" botonEditar === false">
                            <i class="bi-pencil-square me-2"></i>Editar
                        </button>
                    </div>
                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>
                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <!-- FIELD -->
                    <div class="col-md-6">
                        <label for="Field" class="form-label">Username</label>
                        <input class="form-control" type="email" name="username" id="username" [(ngModel)]="user.username" #userName="ngModel" [ngClass]="{'is-invalid': userName.invalid && (userName.dirty || userName.touched)}" (ngModelChange)="mostrarMensaje(userName, 'userName')"
                            (blur)="mostrarMensaje(userName, 'userName')" placeholder="ejemplo@correo.com" required>

                        <!-- Mensaje de error personalizado si el correo no es válido -->
                        <p class="invalid-feedback" *ngIf="userName.invalid && (userName.dirty || userName.touched)">
                            {{ mensajeValidacionUser || 'Formato de correo no válido. Debe contener "@" y un dominio como ".com".' }}
                        </p>
                    </div>

                    <div class="col-md-6">
                        <label for="Field" class="form-label">Roles</label>
                        <select class="form-select select2" multiple="multiple" name="rol" id="rol" [(ngModel)]="user.rol" #rol="ngModel" [ngClass]="{'is-invalid': rol.invalid && (rol.dirty || rol.touched)}" (ngModelChange)="mostrarMensaje(rol, 'rol')" (blur)="mostrarMensaje(rol, 'rol')"
                            required>
                            <ng-container *ngFor="let rol of roles">
                              <option *ngIf="rol.Rls_Activo && rol.Rls_Nombre !== 'varios roles'" [value]="rol.Id_Rol">{{ rol.Rls_Nombre }}</option>
                            </ng-container>
                          </select>

                        <p class="invalid-feedback" [ngStyle]="{ display: showErrorMessageRol ? 'block' : 'none' }" *ngIf="showErrorMessageRol">
                            {{mensajeValidacionRol}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Nombre (s)</label>
                        <input class="form-control" type="text" name="nombre" id="nombre" [(ngModel)]="user.nombre" #nombre="ngModel" [ngClass]="{'is-invalid': nombre.invalid && (nombre.dirty || nombre.touched)}" (ngModelChange)="mostrarMensaje(nombre, 'nombre')" (blur)="mostrarMensaje(nombre, 'nombre')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageNom">
                            {{mensajeValidacionNom}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Apellido Paterno</label>
                        <input class="form-control" type="text" name="ap_paterno" id="ap_paterno" [(ngModel)]="user.ap_paterno" #ap_paterno="ngModel" [ngClass]="{'is-invalid': ap_paterno.invalid && (ap_paterno.dirty || ap_paterno.touched)}" (ngModelChange)="mostrarMensaje(ap_paterno, 'ap_paterno')"
                            (blur)="mostrarMensaje(ap_paterno, 'ap_paterno')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageAP">
                            {{mensajeValidacionAP}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Apellido Materno</label>
                        <input class="form-control" type="text" name="ap_materno" id="ap_materno" [(ngModel)]="user.ap_materno" #ap_materno="ngModel" [ngClass]="{'is-invalid': ap_materno.invalid && (ap_materno.dirty || ap_materno.touched)}" (ngModelChange)="mostrarMensaje(ap_materno, 'ap_materno')"
                            (blur)="mostrarMensaje(ap_materno, 'ap_materno')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageAM">
                            {{mensajeValidacionAM}}
                        </p>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4"> </div>
    </div>


    <!-- FIXED SPACE FOR MAIN FOOTER-->
    <div class="container">
        <div class="row mb-4 pb-4"></div>
    </div>

    <!-- Modal -->
    <div #rolesEliminadosModal class="modal fade" id="rolesEliminadosModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalLabel">Roles Eliminados</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- <div [innerHTML]="mensajeRoles"></div> -->
                    <p>¿Estás seguro de que deseas eliminar el/los siguiente(s) rol(es)?</p>

                    <span class="texto-eliminado"> {{mensajeRoles}} </span>

                    <span class="texto-advertencia">
                        Al hacerlo, se desvincularan los proyectos a los cuales estaba asignado.
                    </span>
                </div>
                <div class="modal-footer">
                    <div class="row w-100">
                        <div class="col-6 text-center">
                            <button type="button" class="btn btn-secondary" (click)="onClose()">Cerrar</button>
                        </div>
                        <div class="col-6 text-center">
                            <button type="button" class="btn btn-danger" (click)="onAccept()">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>




</div>
<!-- END MAIN CONTAINER -->